import React, { Component } from 'react';

import { LabelWithColor } from '../../molecules';
import { Line, MaterialIcon } from '../../atoms';
import { sideBarOptions } from '../../models';

export class SimpleReport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
    this.toggleView = this.toggleView.bind(this);
  }

  // componentDidUpdate() {
  //   // this.state.active ? this.props.items.generateChart(this.props.id) : null;
  // }
  
  componentDidUpdate() {
    // this.state.active ? this.props.items.generateChart(this.props.id) : null;
  }

  renderMask(id, labels) {
    if (typeof document !== "undefined") {
      const header = document.getElementsByClassName("collapsible-header")[0];
      const container = document.getElementById(id + "-container");
      if (header) {
        const angleInc = 2 * Math.PI / (2 * labels.length);
        let angle = angleInc;
        const radius = Math.floor((header.clientWidth ) / 4);
        const center = {
          x: 2 * radius,
          y: radius
        };

        const masks = [];
        for (let i in labels) {
          const label = labels[i];
          const style = {};
          let x = center.x + Math.sin(angle) * radius;
          let y = center.y + Math.cos(angle) * radius;

          if (angle > Math.PI && angle < 2 * Math.PI) {
            style.textAlign = "left";
            x -= 200;
          }
          else if (angle > Math.PI * 0.9 && angle < Math.PI * 1.1) {
            x -= 100;
            style.textAlign = "center";
          }

          if (y < radius) {
            y -= 30;
          }

          style.left = x + "px";
          style.bottom = y + "px";

          masks.push(<div className="label" style={style}>{label}</div>);
          angle += 2 * angleInc;
        }
        return masks;
      }
    }
  }

  renderItems(items, horizontal, small) {
    return items.labels.map((item, i) =>
      <LabelWithColor small={small} horizontal={horizontal} key={i} label={items.labels[i]} style={{ backgroundColor: items.colors[i] }} />
    );
  }

  toggleView() {
    const state = { ...this.state };

    state.active = !state.active;

    this.setState(state);
  }

  renderGraph() {
    const { id, items, noMask } = this.props;
    const mask = (
      <div className="chart-mask">
        {this.renderMask(id, items.labels)}
      </div>
    );
    return (
      <div id={`${id}-container`} className="chart-container">
        <canvas style={{ height: "400px", width: "100%" }} id={id} />
        {noMask ? mask : mask}
      </div>
    );
  }

	render() {
    const legend = {
      labels: [
        "Prática líder de mercado, excelência em gestão",
        "Estágio Avançado",
        "Passos iniciais, oportunidades de melhoria",
        "Nenhuma ação"
      ],
      colors: [
        "rgba(000, 177, 112, .7)",
        "rgba(155, 206, 113, .7)",
        "rgba(224, 232, 124, .7)",
        "rgba(208, 002, 027, .7)"
      ]
    };
    const { label, items, id } = this.props;

    return(
      <ul id={"col-"+id} className="collapsible item simple-report" data-collapsible="accordion" >
        <li>
          <div className="collapsible-header item-container-header flex -v -sb" onClick={this.toggleView}>
            <h4 className="title">{label}</h4>
            <div className="header-items">
              <div className="flex -sb">
                {this.renderItems(items)}
              </div>
              <span className="label">Legenda:</span>
              <div className="legend flex -v -c">
                {this.renderItems(legend, true, true)}
              </div>
            </div>
          </div>
        </li>
      </ul>
		);
	}
}


// WEBPACK FOOTER //
// src/components/common/SimpleReport.js